export enum TrustpilotWidgetVariant {
  reviews = 'reviews',
  stars = 'stars',
  carousel = 'carousel',
  mobileCarousel = 'mobile-carousel',
}

type TrustpilotWidgetSettings = {
  templateId: string
  businessId: string
  height: string
  width: string
  theme: string
  stars?: string
  tags?: string
}

const trustpilotSettings: Record<TrustpilotWidgetVariant, TrustpilotWidgetSettings> = {
  [TrustpilotWidgetVariant.reviews]: {
    templateId: '5419b6a8b0d04a076446a9ad',
    businessId: '5efc648cea967d00018aadfd',
    height: '24px',
    width: '100%',
    theme: 'dark',
  },
  [TrustpilotWidgetVariant.stars]: {
    templateId: '5419b732fbfb950b10de65e5',
    businessId: '5efc648cea967d00018aadfd',
    height: '26px',
    width: '100%',
    theme: 'light',
  },
  [TrustpilotWidgetVariant.carousel]: {
    templateId: '53aa8912dec7e10d38f59f36',
    businessId: '5efc648cea967d00018aadfd',
    height: '140px',
    width: '100%',
    theme: 'light',
    stars: '1,2,3,4,5',
    tags: 'SelectedReview',
  },
  [TrustpilotWidgetVariant.mobileCarousel]: {
    templateId: '539ad0ffdec7e10e686debd7',
    businessId: '5efc648cea967d00018aadfd',
    height: '315px',
    width: '100%',
    theme: 'light',
    stars: '1,2,3,4,5',
    tags: 'SelectedReview',
  },
}

export const useTrustpilotContent = (variant: TrustpilotWidgetVariant) => ({
  trustpilotLinkHref: 'https://www.trustpilot.com/review/tramatm.com',
  trustpilotSettings: trustpilotSettings[variant],
  carouselTitle: 'testimonial-title',
})
